import * as React from 'react';
import styled from 'styled-components';

interface UnlockedIconProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
  size?: number;
}

export const UnlockedIcon: React.FC<UnlockedIconProps> = ({
  className,
  ...props
}) => (
  <svg viewBox="0 0 16 16" {...props} className={className || ''}>
    <path d="M12.15,6.67h-.04v-2.49c0-2.3-1.84-4.17-4.11-4.17S3.89,1.87,3.89,4.17c0,.55,.45,1,1,1s1-.45,1-1c0-1.2,.95-2.17,2.11-2.17s2.11,.98,2.11,2.17v2.49H3.85c-1.39,0-2.52,1.16-2.52,2.59v4.15c0,1.43,1.13,2.59,2.52,2.59H12.15c1.39,0,2.52-1.16,2.52-2.59v-4.15c0-1.43-1.13-2.59-2.52-2.59Zm.5,6.74c0,.28-.22,.51-.5,.51H3.85c-.27,0-.5-.23-.5-.51v-4.15c0-.28,.22-.51,.5-.51H12.15c.27,0,.5,.23,.5,.51v4.15Z" />
  </svg>
);

export default styled(UnlockedIcon)`
  width: ${(props) => (props.size ? `${props.size}px` : `16px`)};
  height: ${(props) => (props.size ? `${props.size}px` : `16px`)};
  path {
    fill: ${({ theme }) => theme.colors.blueColorDark};
  }
`;
